<div class="panel panel-default mt-3">
  <div class="panel-heading">
    <h3 style="display: inline-block">Files</h3>
    <button class="btn btn-primary" (click)="openModalFileUpload()">Easy Upload</button>
  </div>
</div>
